import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import { GitBranch } from 'lucide-react'

interface LocationProjectsEmptyStateProps {
	// Optional: when omitted (e.g. a read-only community account), the create
	// CTA is hidden and the copy adjusts.
	onCreateProject?: () => void
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem 1.5rem;
	text-align: center;
	background: #ffffff;
	border: 1px dashed rgba(0, 0, 0, 0.08);
	border-radius: 12px;
	color: #2d3748;
	width: 100%;
`

const IconWrapper = styled.div`
	width: 96px;
	height: 96px;
	border-radius: 9999px;
	background: rgba(0, 128, 254, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;

	svg {
		width: 48px;
		height: 48px;
		color: #0080fe;
	}
`

const Title = styled.h3`
	font-size: 1.375rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
`

const Description = styled.p`
	max-width: 520px;
	margin: 0 auto 2rem;
	line-height: 1.6;
	color: #4a5568;
`

const LocationProjectsEmptyState: React.FC<LocationProjectsEmptyStateProps> = ({
	onCreateProject,
}) => {
	return (
		<Container>
			<IconWrapper>
				<GitBranch className="w-4 h-4" />
			</IconWrapper>
			<Title>No Projects Yet</Title>
			<Description>
				{onCreateProject
					? 'Start planning this location by creating your first project. Projects help you track tasks, teams, and financials for each initiative.'
					: 'No projects have been added to this location yet.'}
			</Description>
			{onCreateProject && (
				<Button variant="primary" isInput onClick={onCreateProject}>
					Create New Project
				</Button>
			)}
		</Container>
	)
}

export default LocationProjectsEmptyState
